
const Handleiding = () => {
    const handleiding = [
        "Open RexDesk",
        "Plug het influx kastje in de computer",
        "Open het device menu en druk op Reflash",
        "Ga naar C:\\Program Files (x86)\\Influx Technology\\ReXdesk\\Firmware En open RexFirmware.zip",
        "Zoek het Influx serienummer in de linkeronderhoek in RexDesk en type die in het Influx serienummer veld op de website",
        "Vul nu de rest van de velden in",
        "Het moet er nu ongeveer zo uit zien",
        "Voeg eventueel nog hulpstukken toe of importeer ze van een andere machine",
        "Druk op Maak Machine en wacht even",
        "Er is nu een bestand gedownload",
        "Ga terug naar Rexdesk en druk op Internal Storage",
        "In het Internal Storage menu klik op Format SD",
        "Je krijgt nu een menu druk op ja",
        "na dat de SD is geformat druk op Set Time",
        "Druk op Synchronize with PC en druk daarna op Set Time",
        "Nu dat de tijd goed staat druk op open project",
        "Zoek nu naar het gedownloade bestand hij staat waarschijlijk in de Downloads map klik er op en druk op Openen",
        "Nu in Rexdesk druk op Run",
        "Als je ziet configuration uploaded Succesfully dan is het gelukt",
    ]

    return (
        <div className={"w-full h-full"}>
            <ul className={"grid grid-cols-4 gap-4 w-full gap h-full p-8"}>
                <li className={"flex p-4 rounded-xl shadow-gray-300 shadow-sm flex-col bg-white text-left items-center justify-between gap-4"}>
                    <img className={"h-fit rounded-xl w-fit max-h-72"} src={"/Download.PNG"} alt="Handleiding" />
                    <h1 className={"font-bold w-full bg-gray-200 rounded-xl h-full text-2xl p-4 text-wrap"}>Installeer RexDesk door <a className={"underline text-blue-500"} href={"https://downloads.influxtechnology.com/ReXdesk/ReXdesk_1.2.46.0.msi"}>hier</a> te klikken en de instructies in de installer te volgen</h1>
                </li>
                {handleiding.map((item, index) => (
                    <li className={"flex p-4 rounded-xl shadow-gray-300 shadow-sm flex-col bg-white text-left items-center justify-between gap-4"}>
                        <img className={"h-fit rounded-xl w-fit max-h-72"} src={"/Handleiding ("+ (parseInt(index) + 1).toString() +").PNG"} alt="Handleiding" />
                        <h1 className={"font-bold w-full bg-gray-200 rounded-xl h-full text-2xl p-4 text-wrap"}>{index + 1}{".\t"}{item}</h1>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Handleiding;